import { EMGirlType, MgirlNotice } from '@bilibili-maoer/prelude'

import { Button, Container, css, styled } from '@mui/material'

import { Typo } from '~/core/components/alias'

const StyledContainer = styled(Container)`
  min-width: 1000px;
  margin: 50px auto 0;
  padding: 80px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
`

const StyledMgirlNotice = styled(MgirlNotice)`
  position: relative;
  padding-right: 20%;
  img {
    width: 450px;
  }
`

const StyledFloatContainer = styled(Container)`
  position: absolute;
  top: 50px;
  left: 48%;
  width: 50%;
  text-align: left;
`

const StyledButton = styled(Button)(
  ({ theme }) => css`
    width: 196px;
    height: 46px;
    margin: 12px auto;
    border-radius: 4px;
    background-color: ${theme.palette.primary.main};
    transition: 0.3s opacity;
    color: ${theme.palette.common.white};
    font-size: 18px;
    &:hover {
      opacity: 0.7;
      background-color: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};
    }
  `
)

// TODO: 实现顶级 React Error Boundary
export const NotFound = () => (
  <StyledContainer>
    <Container>
      <StyledMgirlNotice
        image={EMGirlType.NotFound}
        description={
          <StyledFloatContainer>
            <Typo variant="h2" sx={{ fontWeight: 'bold' }}>
              404
            </Typo>
            <Typo variant="h6" color="text.secondary" sx={{ marginTop: 2 }}>
              抱歉，你要找的页面迷路了...
            </Typo>
          </StyledFloatContainer>
        }
      />
    </Container>
    <Container sx={{ textAlign: 'center', marginTop: 2 }}>
      <Typo variant="body1" color="text.secondary">
        我们按原路返回好了
      </Typo>
      <StyledButton href="/">返回直播间首页</StyledButton>
    </Container>
  </StyledContainer>
)
